import React from 'react';
import Chart, { Props as ChartProps } from 'react-apexcharts';
import { merge } from 'lodash';

interface BarChartProps extends ChartProps {
  onClick?: (index: number) => void;
}

const BarChart = ({ options, onClick, ...props }: BarChartProps): React.ReactElement => {
  return (
    <Chart
      type="bar"
      options={merge(
        {
          chart: {
            animations: { enabled: props.width === '100%' },
            fontFamily: 'futura-pt',
            toolbar: { show: false },
            zoom: { enabled: false },
            events: {
              dataPointSelection: (_: any, __: any, config: any): void =>
                onClick && onClick(config.dataPointIndex),
              dataPointMouseEnter: (event: any): void => {
                if (!onClick) return;
                if (event.path?.[0]?.style?.cursor) event.path[0].style.cursor = 'pointer';
              }
            }
          },
          plotOptions: {
            bar: { horizontal: false }
          },
          tooltip: {
            enabled: true,
            marker: { show: false },
            theme: 'dark'
          }
        },
        options
      )}
      {...props}
    />
  );
};

export default BarChart;
